import React, { useState } from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const navStyle = ({ isActive }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '0.65rem',
  padding: '0.65rem 1rem',
  borderRadius: '10px',
  fontWeight: 600,
  fontSize: '0.95rem',
  color: isActive ? '#ff6b00' : '#444',
  background: isActive ? '#fff3e8' : 'transparent',
  textDecoration: 'none',
});

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const initials = user?.name
    ? user.name
        .split(' ')
        .map((p) => p[0])
        .join('')
        .slice(0, 2)
        .toUpperCase()
    : 'A';

  const handleLogout = () => {
    logout();
    navigate('/');
    setMenuOpen(false);
  };

  const linkClick = () => setMenuOpen(false);

  return (
    <div style={{ display: 'flex', minHeight: '100vh' }}>
      {/* Mobile top bar */}
      <div
        className="admin-mobile-bar"
        style={{
          display: 'none',
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          zIndex: 100,
          background: '#fff',
          borderBottom: '1px solid var(--border)',
          padding: '0.75rem 1rem',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <strong style={{ color: 'var(--primary)' }}>Ticket Rising</strong>
        <button type="button" className="tr-btn tr-btn-ghost" onClick={() => setMenuOpen((o) => !o)} aria-expanded={menuOpen}>
          {menuOpen ? '✕' : '☰'}
        </button>
      </div>

      <aside
        className={`admin-sidebar ${menuOpen ? 'open' : ''}`}
        style={{
          width: 'var(--sidebar-width)',
          minHeight: '100vh',
          background: '#fff',
          borderRight: '1px solid var(--border)',
          display: 'flex',
          flexDirection: 'column',
          padding: '1.25rem',
          position: 'fixed',
          left: 0,
          top: 0,
          bottom: 0,
          zIndex: 99,
          transform: menuOpen ? 'translateX(0)' : undefined,
        }}
      >
        <div style={{ marginBottom: '2rem' }}>
          <div style={{ fontWeight: 800, fontSize: '1.15rem', color: 'var(--primary)' }}>Ticket Rising</div>
          <div style={{ fontSize: '0.8rem', color: 'var(--text-muted)' }}>Admin</div>
        </div>

        <nav style={{ display: 'flex', flexDirection: 'column', gap: '0.35rem', flex: 1 }}>
          <NavLink to="/admin" end style={navStyle} onClick={linkClick}>
            Dashboard
          </NavLink>
          <NavLink to="/admin/locations" style={navStyle} onClick={linkClick}>
            Locations &amp; QR
          </NavLink>
          <NavLink to="/admin/tickets" style={navStyle} onClick={linkClick}>
            All Tickets
          </NavLink>
        </nav>

        <div style={{ borderTop: '1px solid var(--border)', paddingTop: '1rem' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '1rem' }}>
            <div
              style={{
                width: 40,
                height: 40,
                borderRadius: '50%',
                background: 'var(--primary-soft)',
                color: 'var(--primary)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontWeight: 700,
                fontSize: '0.9rem',
              }}
            >
              {initials}
            </div>
            <div style={{ minWidth: 0 }}>
              <div style={{ fontWeight: 600, fontSize: '0.9rem', overflow: 'hidden', textOverflow: 'ellipsis' }}>{user?.name}</div>
              <div style={{ fontSize: '0.75rem', color: 'var(--text-muted)', textTransform: 'capitalize' }}>{user?.role}</div>
            </div>
          </div>
          <button type="button" className="tr-btn tr-btn-outline" style={{ width: '100%' }} onClick={handleLogout}>
            Log out
          </button>
        </div>
      </aside>

      <main
        className="admin-main"
        style={{
          marginLeft: 'var(--sidebar-width)',
          flex: 1,
          padding: '1.5rem',
          width: '100%',
          paddingTop: '1.5rem',
        }}
      >
        <Outlet />
      </main>

      <style>{`
        .admin-nav-backdrop { display: none; }
        @media (max-width: 900px) {
          .admin-mobile-bar { display: flex !important; }
          .admin-sidebar {
            transform: translateX(-100%);
            transition: transform 0.2s ease;
            box-shadow: 2px 0 12px rgba(0,0,0,0.08);
          }
          .admin-sidebar.open {
            transform: translateX(0);
          }
          .admin-main {
            margin-left: 0 !important;
            padding-top: 4rem !important;
          }
          .admin-nav-backdrop {
            display: block !important;
            position: fixed;
            inset: 0;
            background: rgba(0,0,0,0.35);
            z-index: 98;
            border: none;
            cursor: pointer;
          }
        }
      `}</style>
      {menuOpen && (
        <button type="button" className="admin-nav-backdrop" aria-label="Close menu" onClick={() => setMenuOpen(false)} />
      )}
    </div>
  );
}
